// JavaScript Document
$(function () {

  
  $('.ac-parent').on('click', function () {
    $(this).next().slideToggle();
    //openクラスをつける
    $(this).toggleClass("open");
    //クリックされていないac-parentのopenクラスを取る
    $('.ac-parent').not(this).removeClass('open');

    // 一つ開くと他は閉じるように
    $('.ac-parent').not($(this)).next('.ac-child').slideUp();
  });
  
  $(window).scroll(function(){
	$('.image-block').each(function(){
		var elemPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight +(windowHeight / 2)){
			$(this).addClass('active');
		} 
	});
		
	$('.image-block-fadeIn').each(function(){
		var elemPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight +(windowHeight / 2)){
			$(this).addClass('fadeIn');
		} 
	});
	});
	
});

